import { Typography } from '@mui/material';
import React from 'react';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';

interface Props {
  children?: React.ReactNode | string;
  size?: 'small' | 'normal';
  bold?: boolean;
}

export function Label({ children, size = 'normal', bold = false }: Props) {
  const semantic = useAtlasSemanticThemeTokens();

  const variant = size === 'normal' ? 'textMd' : 'textXs';
  const fontWeight = bold ? 600 : 400;

  return (
    <Typography
      variant={variant as any}
      color={semantic.color.text.muted.value}
      fontWeight={fontWeight}
    >
      {children}
    </Typography>
  );
}
